import { send } from '@fiverr-private/futile/lib/send';

export default function sendGraphiteEvent(event) {
    const data = {
        label: `fe_events.v4_gig_page.${event}.{platform}.{browser}`,
        percentage: 100,
        ttl: -1
    };

    send.sendGraph(data);
}
